<template>
  <div class="container">
    <breadcrumb-group :items="breadcrumbItems"/>

    <heading-one class="-margin-md">メッセージ一覧</heading-one>

    <section>
      <list-group v-if="noticeList.length > 0" class="-link -visited _mb-sm-60 _mb-md-120">
        <list-item v-for="(notice, index) in noticeList" :key="index" class="-link" :class="{unread: notice.disp_status == '0'}" routerName="mb003" :params="{notice_id: notice.notice_id}">
          <span class="date -db">{{notice.notice_date | ymdDateFormat('/')}}</span>
          {{notice.notice_title}}
        </list-item>
      </list-group>
    </section>

  </div><!-- container -->
</template>

<script>
import { getNoticeListLambdaInvoke } from '../utils/LambdaHelper'
import HeadingOne from '../components/heading/HeadingOne'
import ListGroup from '../components/list/ListGroup'
import ListItem from '../components/list/ListItem'
import BtngroupSingle from '../components/button/BtngroupSingle'
import BtnMain from '../components/button/BtnMain'

export default {
  components: {
    BtnMain,
    BtngroupSingle,
    ListItem,
    ListGroup,
    HeadingOne
  },
  name: 'Mb-002',
  metaInfo: {
    title: 'メッセージ一覧',
    meta: [
      {name: 'description', content: 'au PAY スマートローンはau IDをお持ちのお客様のための便利なカードレスローンサービスです。お申込みは、スマートフォン・パソコンでかんたんWEB完結！24時間お申込み可能。最短30分で審査結果をご連絡します。'},
      {name: 'keywords', content: 'au PAY スマートローン,au,カードレスローン,スマートフォン,au PAY 残高,セブン銀行スマホATM,借入,返済,手続き,会員,会員サイト,メッセージ'}
    ]
  },
  data () {
    return {
      breadcrumbItems: [{
        text: 'トップ',
        routerName: 'mb001'
      },
      {
        text: 'メッセージ',
        active: true
      }],
      noticeList: []
      // noticeList: [{
      //   notice_id: '',
      //   notice_date: '',
      //   disp_status: '',
      //   importance: '',
      //   notice_title: ''
      // }]
    }
  },
  mounted () {
    try {
      getNoticeListLambdaInvoke().then(res => {
        let resBody = JSON.parse(res.body)
        this.noticeList = resBody.notices || []
        this.sortNotice()
      }).catch(error => {
        this.goToErrorPage(error)
      })
    } catch (e) {
      this.goToErrorPage(e)
    }
  },
  methods: {
    sortNotice () {
      this.noticeList.sort(function (a, b) {
        // 未読 > 日付
        if (a.disp_status < b.disp_status) return -1
        if (a.disp_status > b.disp_status) return 1
        if (a.notice_date < b.notice_date) return 1
        if (a.notice_date > b.notice_date) return -1
        return 0
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../assets/stylesheets/styles";

  .border-bottom {
    border-bottom:1px $black dotted;
    margin-bottom: 10px;
    a:hover {
      color: $orange;
      text-decoration: underline;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/Mb002.vue